import { MakeCall } from './createMakeCall';

const removePayoutMethod =
  (makeCall: MakeCall) => (methodId: number | string) =>
    makeCall<undefined>('DELETE', `/api/v2/user/me/payout-method/${methodId}`);
export { removePayoutMethod };
